export default {
  methods: {
    validateForm (successCallback, failureCallback) {
      if (!this.$refs.formRef || this.$refs.formRef.$?.type?.name !== 'QForm') {
        console.warn('QForm with ref="formRef" required for validation.')
        failureCallback?.()
        return
      }

      this.$refs.formRef.validate().then(success => {
        if (success) {
          successCallback?.()
        } else {
          failureCallback?.()
        }
      })
    }
  }
}
